import { rtkApi } from 'app/store/AppStore.rtk'
import { DistrictListResponse, School, SportListRequest, SportResponse, State } from 'types'

export const initApi = rtkApi
  .enhanceEndpoints({
    addTagTypes: ['state', 'districts', 'sports', 'school'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getStateById: build.query<State, string>({
        query: (stateId) => `/states/${stateId}`,
        providesTags: ['state'],
      }),

      getDistricts: build.query<DistrictListResponse, string>({
        query: (stateId) => {
          return {
            url: `/districts`,
            params: {
              stateId,
              isActive: true,
              page: 1,
              perPage: 500,
            },
          }
        },
        providesTags: ['districts'],
      }),

      getSchoolById: build.query<School, string>({
        query: (schoolId) => {
          return {
            url: `/school`,
            params: {
              id: schoolId,
            },
          }
        },
        providesTags: ['school'],
      }),

      getSports: build.query<SportResponse, SportListRequest>({
        query: ({ sportId }) => {
          return {
            url: `/sports/${sportId}`,
          }
        },
        providesTags: ['sports'],
      }),
    }),
  })

export const {
  useGetStateByIdQuery,
  useGetDistrictsQuery,
  useGetSportsQuery,
  useGetSchoolByIdQuery,
} = initApi
